import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { I18NextModule } from 'angular-i18next';
import { OrderService } from 'src/app/core/services/order.service';
import { MatSelectModule } from '@angular/material/select';
import {
  MatDatepicker,
  MatDatepickerModule
} from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent
} from '@angular/material/paginator';
import i18next from 'i18next';

@Component({
  standalone: true,
  selector: 'app-modal-table-costs-detail',
  templateUrl: './modal-table-costs-detail.component.html',
  styleUrls: ['./modal-table-costs-detail.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatTableModule,
    MatPaginatorModule
  ]
})
export class ModalTableCostsDetailComponent {
  form: FormGroup;
  dataSource: any[] = [];
  displayedColumns: string[] = [
    'tmaimg',
    'materialType',
    'pressType',
    'projectType',
    'initDate',
    'endDate',
    'preseriesCost',
    'seriesCost',
    'creationDate',
    'recordType',
    'ceco',
    'activityType'
  ];

  length = 100;
  pageSize = 5;
  pageIndex = 1;
  hidePageSize = false;
  pageEvent!: PageEvent;
  dataPagination: any;

  @ViewChild('creationPicker') creationPicker!: MatDatepicker<any>;
  @ViewChild('initPicker') initPicker!: MatDatepicker<any>;
  @ViewChild('endPicker') endPicker!: MatDatepicker<any>;

  constructor(
    public dialogRef: MatDialogRef<ModalTableCostsDetailComponent>,
    private orderService: OrderService,
    public dialog: MatDialog,
    public paginator: MatPaginatorIntl
  ) {
    this.paginator.nextPageLabel = i18next.t('next');
    this.paginator.previousPageLabel = i18next.t('prev');
    this.paginator.itemsPerPageLabel = i18next.t('costsPerPage');

    this.form = new FormGroup({
      tmaimg: new FormControl(''),
      creationDate: new FormControl(''),
      initDate: new FormControl(''),
      endDate: new FormControl('')
    });
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex + 1;
    this.searchCostsDetail();
  }

  searchCostsDetail() {
    const nullIfEmpty = (value: any) => (value === '' ? null : value);

    const tmaimg = nullIfEmpty(this.form.get('tmaimg')?.value);
    const creationDate = nullIfEmpty(this.form.get('creationDate')?.value);
    const initDate = nullIfEmpty(this.form.get('initDate')?.value);
    const endDate = nullIfEmpty(this.form.get('endDate')?.value);

    this.orderService
      .getCostsDetail(this.pageIndex, tmaimg, creationDate, initDate, endDate)
      .subscribe({
        next: (data: any) => {
          this.dataSource = data.costs;
          this.dataPagination = data;
        },
        error: (error) => {
          console.error('Error fetching authorizers:', error);
        },
        complete: () => {
          console.log('Fetch complete');
        }
      });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  close() {
    this.creationPicker['_destroyOverlay']();
    this.initPicker['_destroyOverlay']();
    this.endPicker['_destroyOverlay']();
  }
}
